import type { PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import { useProfileProvider } from "../providers/ProfileProvider";
import ProfileCircularProgressBar from "./ProfileCircularProgressBar";

type Props = {
  progressClassName?: string;
  className?: string;
};

const ProfileInfoProgress = ({
  className,
  children,
  progressClassName,
}: PropsWithChildren<Props>) => {
  const { profileCompletionPercentage, isFetchingProfileCompletion } =
    useProfileProvider();

  return (
    <div className={cn("flex items-center", className)}>
      {children}
      <ProfileCircularProgressBar
        value={profileCompletionPercentage}
        className={progressClassName || ""}
        isLoading={isFetchingProfileCompletion}
      />
    </div>
  );
};

export default ProfileInfoProgress;
